import { SET_SELECTED_DATE, CLEAR_SELECTED_DATE } from "../actions";

export default function filter(state = "", action) {
  switch (action.type) {
    case SET_SELECTED_DATE:
      return action.payload;
    case CLEAR_SELECTED_DATE:
      return "";
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/selectedDate.js